import React from "react";
import { useIsMobile } from '../../utils';
import LinkButton from '../LinkButton/LinkButton';
import { MessageWithAvatar } from './MessageWithAvatar';

import "./MessageWithAvatarAndCTA.scss";

export interface IMessageWithAvatarAndCTAProps {
  avatarName?: string;
  avatarPlacement?: "left" | "right" | "bottom";
  avatarUrl?: string;
  children?: React.ReactNode;
  ctaText?: string;
  ctaUrl?: string;
  /**
   * Function to run when the `<LinkButton />` is clicked.
   */
  ctaCallback?: () => void;
  subject?: string;
}

/**
 * A message with an avatar and CTA. Wraps MessageWithAvatar.
 *
 * @status stable
 */
export const MessageWithAvatarAndCTA: React.FC<IMessageWithAvatarAndCTAProps> = (props) => {

  const { avatarName, avatarUrl, avatarPlacement, ctaText, ctaUrl, children, subject, ctaCallback } = props;

  const isMobile = useIsMobile();

  return (
    <div>
      <MessageWithAvatar
        avatarName={avatarName}
        avatarPlacement={avatarPlacement}
        avatarUrl={avatarUrl}
      >
        <h3>{subject}</h3>
        {ctaUrl && ctaText && isMobile &&
          <LinkButton
            to={ctaUrl}
            buttonClass="primary-button"
            className="message__cta-button--above-message"
            {...(ctaCallback && { onClick: ctaCallback })}
          >
            {ctaText}
          </LinkButton>
        }
        {children}
        {ctaUrl && ctaText && !isMobile &&
          <LinkButton
            to={ctaUrl}
            buttonClass="primary-button"
            {...(ctaCallback && { onClick: ctaCallback })}
          >
            {ctaText}
          </LinkButton>
        }
      </MessageWithAvatar>
    </div>
  );
}
